import { load } from "@fingerprintjs/botd";

export async function detectBot() {
  const botd = await load();
  const result = await botd.detect();

  return result; // result.bot, result.type, result.routine
}